import { render, staticRenderFns } from "./DiscardedDashboard.vue?vue&type=template&id=21dc34c9&"
import script from "./DiscardedDashboard.vue?vue&type=script&lang=js&"
export * from "./DiscardedDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DiscardedDashboard.vue?vue&type=style&index=0&id=21dc34c9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports